import React from 'react';
import { ThemeProvider, createTheme, CssBaseline, Box, AppBar, Toolbar, Typography } from '@mui/material';
import ETFCalculator from './components/ETFCalculator';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#3B82F6' },
    background: { default: '#0F172A', paper: '#1E293B' },
    text: { primary: '#FFFFFF', secondary: '#94A3B8' },
  },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 8 } } },
    MuiPaper: { styleOverrides: { root: { borderRadius: 12 } } },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
        <AppBar position="static" color="transparent" elevation={0}>
          <Toolbar>
            <AccountBalanceWalletIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Portfolio Expert
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{ p: { xs: 1, sm: 3 } }}>
          <Typography
            variant="h3" component="h1" gutterBottom align="center"
            sx={{ mb: 6, color: 'text.primary', display: { xs: 'none', sm: 'block' } }}
          >
            Vermögen & Rente planen
          </Typography>
          <ETFCalculator />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default App;
